/* eslint-disable react/prop-types */
import styles from './styles.module.css'

export const FeedbackButtonGrid = ({
  question,
  options = [],
  onSelect,
  selectedId = null,
  columns = 2,
}) => {
  if (!options.length) return null

  return (
    <div className={styles.feedbackSection}>
      {question && <p className={styles.feedbackQuestion}>{question}</p>}
      <div
        className={styles.feedbackGrid}
        style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
      >
        {options.map((option, index) => {
          const optionId = option.id ?? `${option.label}-${index}`
          const isSelected = selectedId === optionId

          return (
            <button
              key={optionId}
              type="button"
              className={`${styles.feedbackButton} ${isSelected ? styles.feedbackButtonSelected : ''}`}
              aria-pressed={isSelected}
              onClick={() => {
                const handler = option.onClick ?? onSelect
                if (!handler) return

                handler(isSelected ? null : option, index)
              }}
            >
              {option.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default FeedbackButtonGrid
